<template>
  <div class="financeManage-precept-page">
    <p class="hasBottomLine">借贷宝方案管理</p>
    <div class="header-seach-box">
      <div class="inputWithSelectBox">
        <el-input
          placeholder="输入前，请选择抵押币种或者借贷币种"
          :disabled="serchInfo.selectType == 0 ? true : false"
          v-model="serchInfo.selectCoin"
          class="input-with-select"
        >
          <el-select
            v-model="serchInfo.selectType"
            slot="prepend"
            @change="hanldSelectType()"
            placeholder="请选择"
          >
            <el-option label="抵押币种" value="1"></el-option>
            <el-option label="借贷币种" value="2"></el-option>
            <el-option label="全部" value="0"></el-option>
          </el-select>
          <el-button
            slot="append"
            @click="getPageListInfo()"
            icon="el-icon-search"
            >搜索</el-button
          >
        </el-input>
      </div>
      <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')"
        >添加方案</el-button
      >
    </div>

    <div class="table-box">
      <el-table :data="preceptListInfo" border style="width: 99.9%">
        <el-table-column prop="id" label="方案ID" width="80"> </el-table-column>
        <el-table-column prop="mortgageCoin" label="抵押币种">
        </el-table-column>
        <el-table-column prop="borrowCoin" label="借贷币种"> </el-table-column>
        <el-table-column prop="warnRate" label="预警风险率（%）">
        </el-table-column>
        <el-table-column prop="blastRate" label="强平风险率（%）">
        </el-table-column>
        <el-table-column prop="" label="计息方式" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.interestType == 0">按日计息</span>
            <span v-else-if="scope.row.interestType == 1">按时计息</span>
            <span v-else>按日计息,按时计息</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == true">已开启</span>
            <span v-else style="color:red">已停用</span>
          </template>
        </el-table-column>

        <el-table-column prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            <span> {{ scope.row.updateTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="maxDay" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="primary"
              v-if="!scope.row.status"
              @click="preceptStatus(scope.row, true, scope.$index)"
              >启用</el-button
            >
            <el-button
              type="danger"
              v-else
              @click="preceptStatus(scope.row, false, scope.$index)"
              >停用</el-button
            >
            <el-button type="primary" @click="editBtn(scope.row, 'edit')"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="preceptListTotal"
      >
      </el-pagination>
    </div>

    <!---dialog--->

    <el-dialog
      title="方案启停开关"
      class="bk-ui5-dialog"
      :visible.sync="preceptStatusDialog"
    >
      <p class="descText" v-if="editInfo.status == true">
        是否确认停用方案编号为：<span style="color:red"
          >{{ editInfo.id }}
        </span>
        的借贷宝方案？关闭后用户无法在该方案下产生新的抵押借贷申请，停用前已产生的订单不受影响！
      </p>
      <p v-else>
        是否确认启用该借贷宝方案：抵押{{ editInfo.mortgageCoin }}借贷{{
          editInfo.borrowCoin
        }}？
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="preceptStatusDialog = false">取 消</el-button>
        <el-button type="primary" @click="preceptSwitchBtn()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="dialogTitleText"
      class="bk-ui5-dialog"
      :visible.sync="editDialog"
    >
      <!-- <p>{{ editInfo }}</p> -->
      <div class="itemOne">
        <p class="descText">
          <span>抵押币种：</span>
        </p>
        <div class="setInputBox">
          <el-input
            placeholder=""
            :disabled="diaStatus == 'edit' ? true : false"
            v-model="editInfo.mortgageCoin"
          >
          </el-input>
        </div>
      </div>
      <div class="itemOne">
        <p class="descText">
          <span>借贷币种：</span>
        </p>
        <div class="setInputBox">
          <el-input
            placeholder=""
            :disabled="diaStatus == 'edit' ? true : false"
            v-model="editInfo.borrowCoin"
          >
          </el-input>
        </div>
      </div>
      <div class="itemOne">
        <p class="descText">
          <span>预警风险率（%）：</span>
          <span>0﹤X ≤100,支持两位小数 </span>
        </p>
        <div class="setInputBox">
          <el-input placeholder="请输入币种优先级" v-model="editInfo.warnRate">
          </el-input>
        </div>
      </div>
      <div class="itemOne">
        <p class="descText">
          <span>强平风险率（%）：</span>
          <span>0﹤X ≤100,支持两位小数</span>
        </p>
        <div class="setInputBox">
          <el-input placeholder="请输入浮动范围" v-model="editInfo.blastRate">
          </el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editCommitBtn()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import '../store';
import api from '../api';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
  name: 'Precept',
  data() {
    return {
      editDialog: false,
      dialogTitleText: '',
      diaStatus: 'edit',
      preceptStatusDialog: false,
      value: '',
      editInfo: {},
      selectType: '0',
      serchInfo: {
        selectType: '1', //0全部  1 抵押币种 2借贷币种
        selectCoin: '',
        statusType: '0' //0 全部  1停用 2启用
      },

      currentPage: 1,
      pageSize: 10
    };
  },
  computed: {
    ...mapState('FinanceManage', ['preceptListInfo', 'preceptListTotal'])
  },
  methods: {
    ...mapActions('FinanceManage', ['getPreceptList']),
    hanldSelectType() {
      this.serchInfo.selectCoin = '';
    },
    sizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange(val) {
      console.log(`当前页: ${val}`);
      this.getPageListInfo();
    },

    getPageListInfo() {
      let borrowCoin = '';
      let mortgageCoin = '';
      if (this.serchInfo.selectType == 0) {
      } else if (this.serchInfo.selectType == 1) {
        mortgageCoin = this.serchInfo.selectCoin;
        borrowCoin = '';
      } else {
        mortgageCoin = '';
        borrowCoin = this.serchInfo.selectCoin;
      }

      let postData = {
        borrowCoin: borrowCoin,
        mortgageCoin: mortgageCoin,
        page: this.currentPage,
        size: this.pageSize
      };

      this.getPreceptList(postData);
    },

    handleSearch() {},
    showDialog(n) {
      this.dialogArr[n] = true;
    },
    handleOpenSwitch(openStatus) {
      this.dialogArr.openSwitchDialog = true;
      return false;
    },
    clearForm() {
      this.editDialog = false;
      this.preceptStatusDialog = false;
    },

    preceptStatus(row, status, index) {
      this.preceptStatusDialog = true;
      this.editInfo = JSON.parse(JSON.stringify(row));
      this.editInfo.indexNum = index;
    },

    preceptSwitchBtn() {
      let that = this;
      api
        .preceptStatus({
          id: that.editInfo.id,
          status: !that.editInfo.status
        })
        .then(res => {
          if (!res.code) {
            that.$message.success(res.msg);
            that.clearForm();
            that.getPageListInfo();
          } else {
            that.$message.error(res.msg);
          }
        });
    },

    operationBtn() {
      let that = this;
      api.mortgageOperation(that.operationForm).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getMortgageConfig();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    editBtn(row, status) {
      if (status == 'add') {
        this.dialogTitleText = '添加抵押借贷方案';
        this.diaStatus = 'add';
      } else {
        this.dialogTitleText = '编辑抵押借贷方案';
        this.diaStatus = 'edit';
      }
      this.editInfo = JSON.parse(JSON.stringify(row));
      this.editDialog = true;
    },

    editCommitBtn() {
      let that = this;
      let postData2 = JSON.parse(JSON.stringify(this.editInfo));
      let postData = {
        blastRate: this.editInfo.blastRate,
        borrowCoin: this.editInfo.borrowCoin,
        mortgageCoin: this.editInfo.mortgageCoin,
        warnRate: this.editInfo.warnRate,
        id: this.editInfo.id || ''
      };

      if (this.diaStatus == 'add') {
        postData = {
          blastRate: this.editInfo.blastRate,
          borrowCoin: this.editInfo.borrowCoin,
          mortgageCoin: this.editInfo.mortgageCoin,
          warnRate: this.editInfo.warnRate
        };
      }

      api.preceptEdit(postData).then(res => {
        if (!res.code) {
          that.clearForm();
          that.getPageListInfo();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getPageListInfo();
  }
};
</script>

<style lang="less">
.financeManage-precept-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    .inputWithSelectBox {
      width: 500px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-ui5-dialog {
    .el-dialog {
      width: 40%;
      .el-dialog__header {
        text-align: center;
        color: red;
      }
      .el-dialog__body {
        .titleStrong {
          font-size: 18px;
          font-weight: bold;
        }
        .itemOne {
          padding-bottom: 30px;

          .descText {
            display: flex;
            justify-content: space-between;
            text-align: center;
            .el-switch {
              margin-right: 15px;
            }
          }
          .setInputBox {
          }
          .setInputBox2 {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .setRange {
            width: 100%;
            overflow: hidden;
            .rangeItem {
              width: 100%;
              .rangeItemBox {
                width: 50%;
              }
              .rateBox {
                width: 60%;
                float: right;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 0;
                .rateLeft {
                  height: 30px;
                  line-height: 30px;
                  border-left: 1px solid #cccccc;
                  padding-left: 12px;
                }
              }
            }
          }
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
